import ShowMoreButton from './ShowMoreButton';
import MaxCardsAlert from './MaxCardsAlert';
import { useConfigs } from './lib/config-context';
import { jsx as _jsx } from "react/jsx-runtime";
const ColumnLoadMoreWrapper = ({
  shouldRenderCards,
  columnData
}) => {
  const {
    maxCardsPerColumn,
    onShowMore
  } = useConfigs();
  if (!shouldRenderCards) {
    return null;
  }
  const canShowMoreCards = columnData.hasMore && !!onShowMore;
  if (!canShowMoreCards) {
    return null;
  }
  const hasMaxCards = maxCardsPerColumn && columnData.cards.length >= maxCardsPerColumn;
  if (hasMaxCards) {
    return /*#__PURE__*/_jsx(MaxCardsAlert, {});
  }
  return /*#__PURE__*/_jsx(ShowMoreButton, {
    columnData: columnData
  });
};
export default ColumnLoadMoreWrapper;